import { render, staticRenderFns } from "./DnsEdit.vue?vue&type=template&id=759ea558"
import script from "./DnsEdit.vue?vue&type=script&lang=js"
export * from "./DnsEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports